package com.trevorwiebe.timesheet.loads.presentation.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun rememberLoadFilePickerLauncher(
    onFileSelected: (fileName: String, bytes: ByteArray) -> Unit,
): () -> Unit {
    val fileInput = remember {
        (document.createElement("input") as HTMLInputElement).apply {
            type = "file"
            accept = ".pdf,application/pdf"
            asDynamic().style.display = "none"
        }
    }

    DisposableEffect(Unit) {
        document.body?.appendChild(fileInput)
        fileInput.onchange = {
            val file = fileInput.files?.item(0)
            if (file != null) {
                val reader = FileReader()
                reader.onload = { _ ->
                    val buffer = reader.result as ArrayBuffer
                    val bytes = Int8Array(buffer).unsafeCast<ByteArray>()
                    onFileSelected(file.name, bytes)
                    fileInput.value = ""
                    Unit
                }
                reader.readAsArrayBuffer(file)
            }
            Unit
        }
        onDispose {
            document.body?.removeChild(fileInput)
        }
    }

    return { fileInput.click() }
}
